<template>
    <b-modal
        :visible="visible || resetting"
        hide-header
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        centered
        content-class="kiosk-idle-modal"
    >
        <!-- The reset itself: the countdown ran out, or a finished screen
             timed out. Going home is a full page load, so the modal says what
             is happening rather than sitting on a dead screen until the new
             page paints. Nothing to answer here — no Continue button. -->
        <div v-if="resetting" class="text-center resetting">
            <h5 class="mb-0">{{ $t('virtual_kiosk.auto_reset') }}</h5>
            <!-- The same spinner the "Now Starting" panel draws: this is the
                 kiosk going back to that screen, so it should look the same. -->
            <kiosk-spinner class="reset-spinner" />
        </div>

        <div v-else class="text-center">
            <h5 class="mb-3">{{ $t('virtual_kiosk.idle_warning_title') }}</h5>
            <p class="warning-text">{{ $t('virtual_kiosk.idle_warning_message_1') }}</p>
            <p class="warning-text">{{ $t('virtual_kiosk.idle_warning_message_2') }}</p>

            <div class="countdown my-4">
                <div class="countdown-label">{{ $t('virtual_kiosk.idle_auto_reset_label') }}</div>
                <div class="countdown-value">
                    {{ $t('virtual_kiosk.idle_countdown', { n: countdown }) }}
                </div>
            </div>

            <button type="button" class="btn btn-kiosk-continue" @click="$emit('continue-session')">
                {{ $t('virtual_kiosk.continue') }}
            </button>
        </div>
    </b-modal>
</template>

<script>
import KioskSpinner from './KioskSpinner.vue';

export default {
    name: 'KioskIdleWarningModal',
    components: { KioskSpinner },
    props: {
        visible: { type: Boolean, default: false },
        countdown: { type: Number, default: 60 },
        // The session is being reset right now: the warning is over and the
        // page is on its way home.
        resetting: { type: Boolean, default: false },
    },
};
</script>

<style lang="scss" scoped>
.resetting {
    padding: 8px 0 16px;

    .reset-spinner {
        margin: 24px auto 0;
    }
}
.warning-text {
    font-size: 15px;
    white-space: pre-line;
}
.countdown {
    .countdown-label {
        font-size: 14px;
        color: #4d4d4d;
    }
    .countdown-value {
        font-size: 22px;
        font-weight: 600;
        color: #d9534f;
    }
}
.btn-kiosk-continue {
    width: 100%;
    min-height: 56px;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    background-color: #1aa8de;
    border-radius: 4px;
    touch-action: manipulation;

    &:hover,
    &:active {
        color: #fff;
        background-color: #0b89bb;
    }
}
</style>
